enum ROUTES {
  LOGIN = '/login',
  LOGIN_EMAIL = '/login/email',
  LOGIN_VERIFY_TWO_FACTOR = '/login/verify-two-factor',
  LOGIN_SETUP_TWO_FACTOR = '/login/setup-two-factor',
  LOGIN_RESET_PASSWORD = '/login/reset-password',
}

export default ROUTES;
